import React from 'react';

// Icons
import 'font-awesome/css/font-awesome.min.css';

interface Features {
    icon?: string;
    onPress?: () => void;
    iconColor?: string;
    bgColor?: string;
    bgHoverColor?: string;
    rounded?: boolean;
    customClasses?: any;
    iconSize?: string;
}

const IconButton: React.FC<Features> = (props) => {
    // Defaults
    const iconColor = props.iconColor !== undefined ? props.iconColor : 'text-white';
    const bgColor = props.bgColor !== undefined ? props.bgColor : "bg-primary";
    const bgHoverColor = props.bgHoverColor !== undefined ? 'hover:' + props.bgHoverColor : "hover:bg-transparent hover:border-primary hover:text-primary";
    const rounded = props.rounded !== undefined ? 'rounded-full' : null;
    const iconSize = props.iconSize !== undefined ? props.iconSize : "text-base";

    return (
        <div className={`flex items-center justify-between ${props.customClasses}`}>
            <button
                onClick={props.onPress}
                className={`${bgColor} ${bgHoverColor} border border-transparent font-semibold w-10 h-10 flex items-center justify-center focus:outline-none ${rounded} ${iconSize}`}
                type="button"
            >
                <i className={`${props.icon} ${iconColor}`}></i>
            </button>
        </div>
    )
}

export default IconButton;